import { render } from "./EasiestHardestCoursesPage.vue?vue&type=template&id=f4cf54ca"
import script from "./EasiestHardestCoursesPage.vue?vue&type=script&lang=js"
export * from "./EasiestHardestCoursesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__